import { render, staticRenderFns } from "./ProcessDocumentSentMailToModal.vue?vue&type=template&id=6d264daa&scoped=true"
import script from "./ProcessDocumentSentMailToModal.vue?vue&type=script&lang=js"
export * from "./ProcessDocumentSentMailToModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d264daa",
  null
  
)

export default component.exports